var _path, _circle, _path2, _circle2, _path3, _rect, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDryer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.39 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dryer"
  }, "Dryer Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dryer"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75,47.94H2.67A2.59,2.59,0,0,1,.08,45.35V2.88A2.75,2.75,0,0,1,2.83.13H36.75a2.59,2.59,0,0,1,2.59,2.59V45.35A2.59,2.59,0,0,1,36.75,47.94ZM2.83,1.63A1.25,1.25,0,0,0,1.58,2.88V45.35a1.09,1.09,0,0,0,1.09,1.09H36.75a1.09,1.09,0,0,0,1.09-1.09V2.72a1.09,1.09,0,0,0-1.09-1.09Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.83,
    cy: 5.46,
    r: 2.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16.47A12.16,12.16,0,1,1,7.8,28.62,12.17,12.17,0,0,1,20,16.47M20,15A13.66,13.66,0,1,0,33.61,28.62,13.65,13.65,0,0,0,20,15Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.76,
    cy: 5.46,
    r: 2.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.89,19.5a9.11,9.11,0,1,1-9.11,9.1,9.11,9.11,0,0,1,9.11-9.1m0-1A10.11,10.11,0,1,0,30,28.6a10.11,10.11,0,0,0-10.1-10.1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.83,
    y: 9.55,
    width: 37.76,
    height: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.38,3.92V7H6V3.92h9.38m0-1H6a1,1,0,0,0-1,1V7A1,1,0,0,0,6,8h9.38a1,1,0,0,0,1-1V3.92a1,1,0,0,0-1-1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23,34.12a.51.51,0,0,1-.5-.43,2.46,2.46,0,0,1,1.14-2.33c.63-.55.87-.75.41-1.47l-.47-.7c-1-1.49-1.72-2.57-.27-3.66a1.64,1.64,0,0,0,.6-1.75.5.5,0,0,1,.31-.63.51.51,0,0,1,.64.32,2.62,2.62,0,0,1-.95,2.86c-.63.48-.59.67.51,2.31l.47.71c.94,1.44,0,2.24-.6,2.77s-.89.81-.8,1.42a.5.5,0,0,1-.42.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.22,34.12a.5.5,0,0,1-.49-.43,2.44,2.44,0,0,1,1.13-2.33c.64-.55.87-.75.41-1.47l-.46-.7c-1-1.49-1.73-2.57-.27-3.66a1.64,1.64,0,0,0,.59-1.75.5.5,0,0,1,.95-.31,2.61,2.61,0,0,1-.94,2.86c-.64.48-.6.67.5,2.3l.47.72c.94,1.44,0,2.24-.59,2.77s-.9.81-.81,1.42a.49.49,0,0,1-.41.57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.49,34.12a.5.5,0,0,1-.49-.43,2.46,2.46,0,0,1,1.13-2.33c.64-.55.88-.75.41-1.47l-.46-.7c-1-1.49-1.73-2.57-.27-3.66a1.64,1.64,0,0,0,.59-1.75.5.5,0,1,1,1-.31,2.61,2.61,0,0,1-.94,2.86c-.64.48-.6.67.5,2.31l.47.71c.94,1.44,0,2.24-.59,2.77s-.9.81-.8,1.42a.5.5,0,0,1-.42.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryer);
export default __webpack_public_path__ + "static/media/dryer.b7b3191e87794743fd55378209e43426.svg";
export { ForwardRef as ReactComponent };